import {
  Plus, Pencil, Trash2, Download, LogIn, ShieldAlert, KeyRound,
  LifeBuoy, RefreshCw, Siren, Circle,
} from 'lucide-react';

const MAP: Record<string, typeof Plus> = {
  plus: Plus,
  pencil: Pencil,
  'trash-2': Trash2,
  download: Download,
  'log-in': LogIn,
  'shield-alert': ShieldAlert,
  'key-round': KeyRound,
  'life-buoy': LifeBuoy,
  'refresh-cw': RefreshCw,
  siren: Siren,
};

export function AuditIcon({ name, size = 14 }: { name: string; size?: number }) {
  const Comp = MAP[name] ?? Circle;
  return <Comp size={size} />;
}
